import { Contact } from './Contact';
import { FAQ } from './FAQ';
import { Logo } from './Logo';
import { Separator } from './Separator';
import { useLocation } from 'react-router-dom';
import { useDevice } from 'lib/hooks/useDevice';
import { stagePathConfig } from 'data/stage';
import { useTenant } from 'lib/hooks/useTenant';
import { TrustMarks } from './TrustMarks';

type Props = {
  showFAQ?: boolean;
};

const Header = ({ showFAQ }: Props) => {
  const { pathname } = useLocation();
  const { isMobile, isDesktop } = useDevice();
  const { isDA } = useTenant();

  const isInFinishedPage = pathname === stagePathConfig.finished;
  const isInPaymentStage = pathname === stagePathConfig.payment;
  const shouldFAQButtonBeShown = !isInFinishedPage && !isInPaymentStage;

  return (
    <>
      <header
        id="top-header"
        className="sticky top-0 z-20 h-20 border-b border-light-800 bg-light-600 px-5"
        data-testid="header"
      >
        <div
          className={`mx-auto h-full ${
            isDA ? 'max-w-[1320px]' : 'max-w-screen-lg'
          }`}
        >
          <div
            className={
              isDA ? 'flex h-20 items-center' : 'flex h-full items-center'
            }
          >
            <Logo />
            {isDA ? (
              <div
                className="ml-12 hidden lg:block"
                data-testid="header-desktop-trust-marks"
              >
                <TrustMarks />
              </div>
            ) : null}
            <div className="flex flex-1 items-center justify-end gap-2.5 md:gap-5">
              {isMobile ? <Contact /> : null}
              {shouldFAQButtonBeShown && (
                <>
                  {isMobile ? <Separator /> : null}
                  <div className="flex items-center gap-2.5">
                    <FAQ isVisible={showFAQ} />
                  </div>
                  {isDesktop ? <Separator /> : null}
                </>
              )}
              {isDesktop ? <Contact /> : null}
            </div>
          </div>
        </div>
      </header>
      {isDA ? (
        <div
          className="h-10 border-b border-light-800 bg-light-600 px-5 lg:hidden"
          data-testid="header-compact-trust-marks"
        >
          <div className="mx-auto flex h-full max-w-[1320px] items-center justify-center">
            <TrustMarks compact />
          </div>
        </div>
      ) : null}
    </>
  );
};

export { Header };
